import React, { FC } from 'react';
import { Box, Button, Center, HStack, Text, VStack } from '@chakra-ui/react';
import { Icon } from '@app/components/Icon';
import { useRouter } from 'next/router';

interface Props {
  isNitroAvailable: boolean;
  onComplete: () => void;
}

export const CompleteWizardBanner: FC<Props> = ({
  isNitroAvailable,
  onComplete
}) => {
  const router = useRouter();

  return (
    <>
      <Box
        sx={{
          maxWidth: ['100vw', '586px'],
          padding: '48px 32px',
          backgroundColor: 'neutral.800',
          border: '1px solid',
          borderColor: 'neutral.700',
          borderRadius: '8px',
          marginTop: 8,
          marginInline: 'auto'
        }}
      >
        <VStack w="100%" gap={0}>
          <Center w="140px" h="140px" borderRadius="50%" bg="success">
            <Center
              w="93px"
              h="93px"
              borderRadius="50%"
              bg={'#2f6930'}
              sx={{
                filter:
                  'drop-shadow(0px 4.320987701416016px 12.098764419555664px rgba(0, 0, 0, 0.71))'
              }}
            >
              <Icon name={'check'} style={{ width: 96, height: 96 }} />
            </Center>
          </Center>
          <Box mt="48px" w="100%">
            <Text
              textAlign="center"
              w="100%"
              color="white"
              fontSize="26px"
              fontWeight={500}
              lineHeight="32px"
            >
              You have completed the position wizard
            </Text>
            <Text
              w="100%"
              color="whiteOpacity.50"
              fontSize="18px"
              lineHeight="20px"
              fontWeight={400}
              mt="12px"
              textAlign="center"
            >
              You can view your new position on Positions page
            </Text>
          </Box>
        </VStack>
        <HStack justifyContent="space-between" gap="16px" mt="43px">
          <Button
            w="100%"
            bg="gray.7"
            py="10px"
            px="20px"
            borderRadius="12px"
            onClick={async () => {
              router.push('/positions');
            }}
            color="white"
            _hover={{ filter: 'brightness(120%)' }}
          >
            <Text
              fontSize="16px"
              fontFamily="'Inter', sans-serif"
              fontWeight="500"
              lineHeight="20px"
            >
              Your positions
            </Text>
          </Button>
          <Button
            w="100%"
            bg="orange"
            py="10px"
            px="20px"
            borderRadius="12px"
            onClick={async () => {
              if (isNitroAvailable) {
                onComplete();
              } else {
                router.push('/positions');
              }
            }}
            color="white"
            _hover={{ filter: 'brightness(120%)' }}
          >
            <Text
              fontSize="16px"
              fontFamily="'Inter', sans-serif"
              fontWeight="500"
              lineHeight="20px"
            >
              Done
            </Text>
          </Button>
        </HStack>
      </Box>
    </>
  );
};
